// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_dw-0";
export var headerCellHover = "_dw-1";